module.exports = __webpack_public_path__ + "img/625.3d4e60eb.jpg";